import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Layout from "./../components/Layout";
import StandalonePageLayout, {
  WhiteBox,
} from "./../components/StandalonePageLayout";

const PrivacyPage = () => {
  const termsQuery = useStaticQuery(graphql`
    {
      craftPrivacyPolicyPrivacyPolicyEntry {
        title
        richTextField
      }
    }
  `).craftPrivacyPolicyPrivacyPolicyEntry;
  const { title, richTextField } = termsQuery;

  return (
    <Layout
      backgroundColor={"var(--turquoise)"}
      footerColor={"var(--turquoise)"}
      headerColor={"var(--black)"}
      headerBlack
      title={title}
    >
      <StandalonePageLayout>
        <h1>{title}</h1>
        <WhiteBox>
          <div dangerouslySetInnerHTML={{ __html: richTextField }} />
        </WhiteBox>
      </StandalonePageLayout>
    </Layout>
  );
};

export default PrivacyPage;
